module.exports = __webpack_public_path__ + "static/media/34DSS3.892ce771.jpg";